import { CpCommerceConstants } from '../../sdk';
import * as fromDatatype from '../datatype-library/index';
import { ShippingConfigJsonTypeInterface } from './shipping_config_json.model';

// linking to other database table.

export interface bl_cms_website_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  host_name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  pricebook_guid: fromDatatype.GuidDataFieldInterface;
  pricing_logic: fromDatatype.VarcharDatatypeInterface;
  stock_logic: CpCommerceConstants.BlCmsWebSiteHdrConstants.MKP_STOCK_SRC | CpCommerceConstants.BlCmsWebSiteHdrConstants.ECOMSYNC_STOCK_SRC;
  content_category_label_list_guid: fromDatatype.GuidDataFieldInterface;
  title_writer: fromDatatype.VarcharDatatypeInterface;
  meta_desc: fromDatatype.VarcharDatatypeInterface;
  scheme_generator: fromDatatype.JsonDatatypeInterface;
  shipping_config_json: ShippingConfigJsonTypeInterface;
}

export class bl_cms_website_hdr_RowClass
  implements bl_cms_website_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    host_name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
    pricebook_guid: fromDatatype.GuidDataFieldInterface;
    pricing_logic: fromDatatype.VarcharDatatypeInterface;
    stock_logic: CpCommerceConstants.BlCmsWebSiteHdrConstants.MKP_STOCK_SRC | CpCommerceConstants.BlCmsWebSiteHdrConstants.ECOMSYNC_STOCK_SRC;
    content_category_label_list_guid: fromDatatype.GuidDataFieldInterface;
    title_writer: fromDatatype.VarcharDatatypeInterface;
    meta_desc: fromDatatype.VarcharDatatypeInterface;
    scheme_generator: fromDatatype.JsonDatatypeInterface;
    shipping_config_json: ShippingConfigJsonTypeInterface;
  }
